import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "ilsctlLineItemHeader",

  setup(_props, _ctx) {
    return {};
  },
});
